import ItemCategory from './ItemCategory.jsx';

export {
  ItemCategory
}


// WEBPACK FOOTER //
// ./components/partials/item-category/index.js